export const UTM_STORAGE_KEY = 'utm-params'

export const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']

const readSearch = (search) => {
  if (typeof search === 'string') return search
  if (typeof window === 'undefined') return ''
  return window.location.search
}

export const getStoredUtmParams = () => {
  try {
    const raw = window.localStorage.getItem(UTM_STORAGE_KEY)
    if (!raw) return null

    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null

    const utm = {}
    UTM_KEYS.forEach((key) => {
      if (typeof parsed[key] === 'string' && parsed[key]) {
        utm[key] = parsed[key]
      }
    })

    return Object.keys(utm).length ? utm : null
  } catch (error) {
    return null
  }
}

export const persistUtmParamsFromUrl = (search) => {
  try {
    const params = new URLSearchParams(readSearch(search))
    const utm = {}

    UTM_KEYS.forEach((key) => {
      const value = params.get(key)
      if (value) utm[key] = value
    })

    if (!Object.keys(utm).length) return getStoredUtmParams()

    window.localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utm))
    return utm
  } catch (error) {
    return getStoredUtmParams()
  }
}

export const withUtmParams = (data = {}) => {
  const utm = getStoredUtmParams()
  return utm ? { ...data, ...utm } : data
}

export const appendUtmParamsToFormData = (formData) => {
  const utm = getStoredUtmParams()
  if (!utm) return formData

  Object.entries(utm).forEach(([key, value]) => {
    formData.append(key, value)
  })

  return formData
}
